<template>
  <div>
    <b-overlay :show="isLoadingData" rounded="sm">
      <b-row>
        <b-col cols="4">
          <b-card header="Due Diligence Reports">
            <b-card-body class="scrollFlow" style="height: 240px; overflow: hidden auto;">
              <div v-for="(reports,index) in dueDiligenceReportsData" :key="index">
                <h6
                  class="text-primary"
                  @click="getDueDiligenceImageCallFunction(reports)"
                  style="cursor: pointer;"
                >
                  <u>{{ reports.title }}</u>
                </h6>
                <p>{{ "Gernerted Date: "+ reports.date }}</p>
                <br />
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card header="Recent Monitoring Results">
            <b-card-body class="scrollFlow" style="height: 240px; overflow: hidden auto;">
              <div v-for="(monitoringData,index) in recentMonitoringData" :key="index">
                <h6
                  class="text-primary"
                  @click="getRecentMonitoringImageCallFunction(monitoringData)"
                  style="cursor: pointer;"
                >
                  <u>{{ monitoringData.title }}</u>
                </h6>
                <br />
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card header="Remediated Results">
            <b-card-body class="scrollFlow" style="height: 240px; overflow: hidden auto;">
              <div v-for="(remediated,index) in remediatedData" :key="index">
                <h6
                  class="text-primary"
                  @click="getRemediatedImageCallFunction(remediated)"
                  style="cursor: pointer;"
                >
                  <u>{{ remediated.title }}</u>
                </h6>
                <p>{{ remediated.subtitle }}</p>
                <br />
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
export default {
  name: "DueDiligenceRemediationMonitoringTabComponent",
  data() {
    return {
      dueDiligenceReportsData: [],
      recentMonitoringData: [],
      remediatedData: [],
      isLoadingData: false
    };
  },
  mounted() {
    this.getTpDueDiligenceReports();
    this.getTpRecentMonitoringResults();
    this.getTpRemediatedResults();
  },
  methods: {
    async getTpDueDiligenceReports() {
      let formData = {
        thirdPartyId: this.$route.params.thirdPartyId,
        companyId: this.$route.params.companyId
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.isLoadingData = true;
        let result = await HTTP(
          "post",
          "thirdparty/duediligencereports",
          formData,
          {
            Authorization: token
          }
        );
        if (result && result.data.status == 1 && result.status == 200) {
          this.dueDiligenceReportsData = result.data.response;
          this.isLoadingData = false;
          this.$store.state.dueDiligenceRemediationMonitoringTabLazyLoad = false;
        } else {
          this.dueDiligenceReportsData = [];
          this.isLoadingData = false;
          this.$store.state.dueDiligenceRemediationMonitoringTabLazyLoad = false;
        }
      } catch (error) {
        this.isLoadingData = false;
      }
    },
    async getTpRecentMonitoringResults() {
      this.recentMonitoringData = [];
      let formData = {
        thirdPartyId: this.$route.params.thirdPartyId
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.isLoadingData = true;
        let result = await HTTP(
          "post",
          "thirdparty/recentmonitoringresults",
          formData,
          {
            Authorization: token
          }
        );
        if (result && result.data.status == 1 && result.status == 200) {
          this.recentMonitoringData = result.data.response;
          this.isLoadingData = false;
          this.$store.state.dueDiligenceRemediationMonitoringTabLazyLoad = false;
        } else {
          this.recentMonitoringData = [];
          this.isLoadingData = false;
          this.$store.state.dueDiligenceRemediationMonitoringTabLazyLoad = false;
        }
      } catch (error) {
        this.isLoadingData = false;
      }
    },
    async getTpRemediatedResults() {
      this.remediatedData = [];
      let formData = {
        thirdPartyId: this.$route.params.thirdPartyId,
        companyId: this.$route.params.companyId,
        memberId: localStorage.getItem("userId")
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.isLoadingData = true;
        let result = await HTTP(
          "post",
          "thirdparty/remediatedresults",
          formData,
          {
            Authorization: token
          }
        );
        if (result && result.data.status == 1 && result.status == 200) {
          this.remediatedData = result.data.response;
          this.isLoadingData = false;
          this.$store.state.dueDiligenceRemediationMonitoringTabLazyLoad = false;
        } else {
          this.remediatedData = [];
          this.isLoadingData = false;
          this.$store.state.dueDiligenceRemediationMonitoringTabLazyLoad = false;
        }
      } catch (error) {
        this.isLoadingData = false;
      }
    },
    getRecentMonitoringImageCallFunction(data) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/" + data.url;
      window.open(urlAddress);
    },
    getRemediatedImageCallFunction(data) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/" + data.url;
      window.open(urlAddress);
    },
    getDueDiligenceImageCallFunction(reports) {
      let srch_id = null;
      let tp = null;
      let comp_id = null;
      let cor_id = null;
      let is_moni = null;
      let date_res = null;
      if (reports.report_type == "printRpt") {
        srch_id = reports.param.srch_id;
        tp = reports.param.tp;
        this.printRpt(srch_id, tp);
      } else if (reports.report_type == "printRpt2") {
        srch_id = reports.param.srch_id;
        this.printRpt2(srch_id);
      } else if (reports.report_type == "printRptt") {
        srch_id = reports.param.srch_id;
        comp_id = reports.param.comp_id;
        cor_id = reports.param.cor_id;
        is_moni = reports.param.is_moni;
        tp = reports.param.tps;
        this.printRptt(srch_id, comp_id, cor_id, is_moni, tp);
      } else if (reports.report_type == "printRptt2") {
        srch_id = reports.param.srch_id;
        comp_id = reports.param.comp_id;
        date_res = reports.param.date_res;
        is_moni = reports.param.is_moni;
        tp = reports.param.tps;
        this.printRptt(srch_id, comp_id, date_res, is_moni, tp);
      } else if (reports.report_type == "edd") {
        let urlAddress = process.env.VUE_APP_BASE_URL + "/" + reports.path;
        window.open(urlAddress);
      }
    },
    printRptt(srch_id, comp_id, cor_id, is_moni, tps) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/free20_rpt_gen?srch_id=" + srch_id + "&comp_id=" + comp_id + "&cor_id=" + cor_id + "&is_moni=" + is_moni + "&tp=" + tps;
      window.open(urlAddress);
    },
    printRptt2(srch_id, comp_id, date_res, is_moni, tps) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/free20_rpt_gen?srch_id=" + srch_id + "&comp_id=" + comp_id + "&is_moni=" + is_moni + "&date_res=" + date_res + "&tp=" + tps;
      window.open(urlAddress);
    },
    printRpt(srch_id, tp) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/free20_rpt_gen?srch_id=" + srch_id + "&tp=" + tp;
      window.open(urlAddress);
    },

    printRpt2(srch_id) {
      let urlAddress = process.env.VUE_APP_BASE_URL + "/free20_rpt_gen?srch_id=" + srch_id + "&tp=3";
      window.open(urlAddress);
    }
  }
};
</script>
<style scoped>
.scrollFlow::-webkit-scrollbar {
  display: none;
}
</style>